import { configureStore } from '@reduxjs/toolkit'
import registerReduser from './features/auth/registerSlice';
import loginReduser from './features/auth/loginSlice';
import userReducer from './features/auth/userSlice';
import tripSlice from "./features/admin/tripSlice";
import policySlice from "./features/admin/policySlice"
import serviceSlice from "./features/admin/serviceSlice";
import articleSlice from "./features/admin/articleSlice";
import placeSlice from  "./features/admin/placeSlice";
import settingSlice from  "./features/admin/settingSlice";
import flightSlice from  "./features/admin/flightSlice";
import adminBookingSlice from  "./features/admin/adminbookingSlice";
import adminTripBookingSlice from  "./features/admin/adminTripBookingSlice";
import bookingTripSlice from  "./features/home/bookTripSlice";
import roomSlice from  "./features/admin/roomSlice";
import favoriteslice from  "./features/home/favSlice";
import bookingSlice from  "./features/home/bookingSlice";
import OptionalServiceSlice from  "./features/admin/additionalServiceSlice";
const store = configureStore({
    reducer: {
        register: registerReduser,
        login:loginReduser,
        user: userReducer,
        tripSlice,
        policySlice,
        serviceSlice,
        articleSlice,
        placeSlice,
        settingSlice,
        flightSlice,
        roomSlice,
        favoriteslice,
        bookingSlice,
        bookingTripSlice,
        OptionalServiceSlice,
        adminBookingSlice,
        adminTripBookingSlice

    }
})
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;